// src/circular/styles.ts
import { css, keyframes } from "@emotion/react";
var rotate = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var spin = keyframes({
  "0%": {
    strokeDasharray: "1, 400",
    strokeDashoffset: "0"
  },
  "50%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-100"
  },
  "100%": {
    strokeDasharray: "400, 400",
    strokeDashoffset: "-260"
  }
});
var trackColorSx = {
  primary: {
    stroke: "var(--colors-primary-10)"
  },
  secondary: {
    stroke: "var(--colors-neutrals-10)"
  }
};
var circularProgressCX = css`
  display: flex;
  position: relative;
`;

export {
  rotate,
  spin,
  trackColorSx,
  circularProgressCX
};
